<ion-header class="toolbar-no-padding">
  <app-header pageName={{title}}>
    <ion-buttons end>
    </ion-buttons>
  </app-header>
</ion-header>
<!-- <ion-content forceOverflow="false"> -->
  <div class="buttons">
    <ion-button class="danger" data-cy="twoOptCancelBtn" (click)="selectOption(false)"> {{cancel}} </ion-button>
    <ion-button class="success" data-cy="twoOptOkBtn" (click)="selectOption(true)"> {{success}} </ion-button>
  </div>
<!-- </ion-content> -->